import { FaTimes } from 'react-icons/fa';

import styles from './ConsentHeader.module.css';

interface ConsentHeaderProps {
  onClose: () => void;
}

export default function ConsentHeader({
  onClose,
}: ConsentHeaderProps): JSX.Element {
  return (
    <header className={styles.bannerHeader}>
      <h2 id="analytics-consent-title">Controle sua privacidade</h2>
      <button
        className={styles.closeButton}
        type="button"
        aria-label="Fechar preferências de cookies"
        onClick={onClose}
      >
        <FaTimes size={16} aria-hidden="true" />
      </button>
    </header>
  );
}
